import React, { useCallback, useContext, useEffect, useRef, useState } from 'react';
import strs from './strings';
import { Spacer, Spacer10, Spacer25, Spacer100, Notification, DragNDrop, BackButton, LoadingDocs, DragNDropBriefcase } from './Utils';
import { createBrowserRouter, RouterProvider, useNavigate, Link } from 'react-router-dom';
import caseTerms from './case';
import curCase from './testCase';
import { Button, Select, useMediaQuery } from '@mui/material';
import { dateString, receiveNotification } from './utilFunctions';
import { FormContext } from './context';
import { getFirestoreDoc, setCase, setFirestoreDoc, setPending } from './firestore';
import Confetti from "react-confetti";
import newCaseImg from './imgs/test.svg';
import logo from './imgs/continentalis-isotipo.png';
import docsAll from './docs';
import { auth } from './firebase';
import { getFile } from './googleCloudStorage';
import { nanoid } from 'nanoid';

const lang = strs.en;

export function LogoutPopup(props) {
	return (
		<div className='small-popup'>
			<h3 className='secondary-title'>Logout</h3>
			<Spacer />
			<p className='p'>Are you sure you want to logout</p>

			<div className='popup-btn-grid'>
				<button className='popup-andrey-button-2'>{lang.goBack}</button>
				<button className='popup-andrey-button'>{lang.logout}</button>
			</div>

		</div>
	);
}


export function SubmitApplicationPopup(props) {
	const navigate = useNavigate();
	let isMobilePortraitScreen = !useMediaQuery('screen and (min-width: 756px)');	
	const {globalForm, setGlobalForm} = useContext(FormContext);

	function closePopup() {
// 		props.closeFunc('fade-out');
// 		setTimeout( () => props.closeFunc('hidden')
// 		, 500);
		props.closeFunc('hidden');
	}

	const handleEscapePress = (event) => {
		if (event.key === 'Escape' && props.submitPopup === 'animated-div') closePopup();
	}

	useEffect(() => {
		document.addEventListener('keyup', handleEscapePress);
	})

	return (

	<div className={`popup ${props.submitPopup}`}>
		<div className='inner-popup'>
			<div className='flex-column '>
			<div className='center-flex'>
				<img src={newCaseImg} alt='new case image' width='300' />
			</div>
			<Spacer />
			{isMobilePortraitScreen && <Spacer />}
			<center><h1 className='secondary-title centered-text'>{lang.popupTitleSubmit}</h1></center>
			<Spacer />
			<p className="popup-inner p">{lang.popupMessageSubmit}</p>
			<br/>
			<p className='popup-inner p'>{lang.popupMessagePartialSubmission}</p>
			<Spacer />
			<div className='popup-btn-grid'>
				<button className='popup-andrey-button-2' id="grab-focus" onClick={() => closePopup()}>{lang.goBack}</button>
				<button className='popup-andrey-button' onClick={ async () => {
					const tmpForm = {
						...globalForm,
						basicInfo: {
							...globalForm.basicInfo,
							dateOfBirth: globalForm.basicInfo.dateOfBirth.toISOString(),
						},
						curStatus: "submitted",
						dateSubmitted: dateString(),
					}
					let r = await setPending(tmpForm);
					if (r.error) return; 
					r = await setCase(tmpForm.id, tmpForm);	
					if (r.error) return;
					navigate('/submission-successful');
				}
				}>{lang.submitApplication}</button>
			</div>
			</div>
		</div>
	</div>

	);
}

export function SubmissionSuccessful() {
	const navigate = useNavigate();
	const subm = lang.submissionDisclaimer;
	return(

	<div>
		<Confetti />
		<Spacer100 />
		<h1 className='center-flex secondary-title'>{lang.submissionSuccessful}</h1>
			<Spacer100 />
			<div className='center-flex'>
			<img className='logo-login' alt="logo" src={logo}/>
			</div>
		<Spacer100 />
		<div className='centered-text'>
			<p className='popup-inner p'>{subm.sec0}<b>{subm.sec1}</b>{subm.sec2}<b>{subm.sec3}</b>{subm.sec4}<b>{subm.sec5}</b>{subm.sec6}<i>{subm.sec7}</i></p>
		</div>
		<Spacer100 />
		<div className='center-flex'>
			<button className='popup-andrey-button' id="grab-focus" onClick={() => navigate('/')} >{lang.goHome}</button>
		</div>
	</div>
	);
}

export function DraftSaved() {
	return (
		<div className='draft-saved'>
			<p>{lang.draftSaved}</p>	
		</div>
	);
}



export function ReceiveNotificationPopup(props) {
	const navigate = useNavigate();
	const {thisCase} = useContext(FormContext);
	//Just easy to alias this
	const curCase = thisCase;
	const thisNotification = props.notification;
	console.log('popup Notification', props)

	let isMobilePortraitScreen = !useMediaQuery('screen and (min-width: 756px)');	

	const remainingDays = curCase.days;
	let remainingDaysMsg = caseTerms.remainingDays.replace("DAYS", curCase.days);

	if (remainingDays === 1) {
		remainingDaysMsg = remainingDaysMsg.replace("days", "day");
	}
	
	
	function closePopup() {
// 		props.closeFunc('fade-out');
// 		setTimeout( () => props.closeFunc('hidden')
// 		, 500);
		props.closeFunc('hidden')
	}

	function handleClick() {
		receiveNotification(thisNotification, curCase);
		props?.setNotification?.(false);
		props?.addToReceivedNotifications('notification1');
		props?.setReceiving(true);

		closePopup();
	}

	const handleEscapePress = (event) => {
// 		console.log('visible', props.trigger)
		console.log('ReceiveNotification handleEscapePress');
		if (event.key === 'Escape' && props.trigger !== 'hidden') {
			console.log('ReceiveNotification handleEscapePress closing popup')
			closePopup();
		}
	}

	useEffect(() => {
		document.addEventListener('keydown', handleEscapePress);
	})

	return (

	<div className={`popup ${props.submitPopup}`}>
		{isMobilePortraitScreen && <Spacer />}
		<div className='flex-column'>
		<center><h1 className='secondary-title'>{caseTerms.receiveConfirmation}</h1></center>
		<Spacer />
		<p className="popup-inner centered-text">{caseTerms.receiveDisclaimer}</p>
		<Spacer />
		<p className="popup-inner centered-text">{remainingDaysMsg}</p>
		<Spacer />
		<div className='popup-btn-grid'>
			<button className='popup-andrey-button-2' onClick={() => closePopup()}>{lang.goBack}</button>
			<button className='popup-andrey-button' onClick={handleClick}>{caseTerms.receiveNotification}</button>
		</div>
		</div>
	</div>

	);
}

export function FullscreenDocument(props) {
	const navigate = useNavigate();
// 	let isMobilePortraitScreen = !useMediaQuery('screen and (min-width: 756px)');	
	const containerRef = useRef(null); // Ref for the wrapper element	

	function closePopup() {
		props.closeFunc('hidden');
	}

	const handleEscapePress = (event) => {
		console.log('escape', props)
		console.log('src', props.src)
// 		if (event.key === 'Escape'){
// 			console.log('if')
// 			closePopup();
// 		} 
		closePopup();
	}

	useEffect(() => {
		document.addEventListener('keyup', handleEscapePress);
		window.addEventListener('blur', handleEscapePress); // Detect focus loss when iframe is clicked

		return () => {
			document.removeEventListener('keyup', handleEscapePress);
			window.removeEventListener('blur', handleEscapePress);
		};
	});

	return(
		<div className={`${props.visible} center-flex`} ref={containerRef}>
			<embed className={`${props.visible}`} title="upload-box" src={props.src} />
		</div>

	)
}

export function DocumentsGridPopup(props) {
	const containerRef = useRef(null);
	const lang = strs.en;
	const docsList = docsAll.en;
	const [globalForm, setGlobalForm] = useState({docs: []})	
	const [isLoading, setIsLoading] = useState(true);
	const [iframeDoc, setIframeDoc] = useState('');
	const [isIframe, setIsIframe] = useState('hidden');
	let isMobilePortraitScreen = !useMediaQuery('screen and (min-width: 756px)');
	const uid = auth.currentUser.uid;
	const onSelect = props.onSelect;
	const {resolverRef} = useContext(FormContext);
	console.log('resolverRef DocumentsGridPopup', resolverRef.current);

	const colorStyles = {
		control: (styles) => ({
			...styles,
	// 		color: 'black',
			backgroundColor: '#f5f6f7',
			border: '1px solid gray',
	// 		minWidth: '636px',
			minHeight: '48px',
	// 		margin: '1rem'
		}),
	}


	useEffect(() => {
		// Define an async function inside useEffect
		const fetchUrls = async () => {
		//TODO: catch this promise.
			let docsPromise = await getFirestoreDoc(`/documents/${uid}`)
			let docs = docsPromise.docs;
			console.log('firebaseDocs', docs)
			if (!docs?.length) {
				setIsLoading(false);
				return;
			}
			// Use Promise.all to handle multiple async operations
// 			const updatedDocs = await Promise.all(curCase.docs.map(async (doc) => {
// 				const response = await fetch(doc.url);
// 				const file = await response.blob();
// 				const url = URL.createObjectURL(file);
// 				doc.url = url;
// 				return doc; // Ensure to return doc for Promise.all
// 			}));
			const updatedDocs = await Promise.all(docs.map(async (doc) => {
				const file = await getFile(doc.uuid)
				const url = URL.createObjectURL(file);
				doc.url = url;
				return doc; // Ensure to return doc for Promise.all
			}));


			// Optionally, update state or perform other operations with updatedDocs
			console.log('after useEffect', updatedDocs);
			setGlobalForm({docs: [...updatedDocs]});
			setIsLoading(false)
		};

		fetchUrls(); // Call the async function

		console.log('docsList', docsList)

	}, [uid]); 

	const handleEscapePress = (event) => {
		if (event.key === 'Escape') {
			props?.setIsVisible('hidden');
		}
	}

	useEffect(() => {
		document.addEventListener('keyup', handleEscapePress);
	})


	const [ formData, setFormData ] = React.useState({
		docType: null,
		doc: null,
		textArea: "",
	});
	const [uploadedFile, setUploadedFile] = React.useState(null);

	
	function handleChange (selectedOption) {
		setFormData({
			...formData,
			docType: selectedOption.value,
		})
		console.log('formData', formData);
	}


	async function uploadDoc() {
		console.log('doc', uploadedFile);
// 		setClientDocsState((prevDocs) => ([
// 			{docType: docs[formData.docType], doc: URL.createObjectURL(uploadedFile)},
// 			...prevDocs,
// 		]));

		let tmp = {
			...uploadedFile,
			msg: formData?.textArea,
		}
		setUploadedFile(tmp);
		let curDocs = await getFirestoreDoc(`/documents/${uid}`)
		const lastIdx = curDocs?.docs.length - 1;
		let lastDoc = curDocs?.docs[lastIdx]
		lastDoc.msg = formData?.msg;
		curDocs.docs[lastIdx].msg = formData?.textArea;
		console.log('curDocs', curDocs);
		setFirestoreDoc(`/documents/${uid}`, curDocs);
		


		setFormData( () => ( {
			docType: null,
			doc: null,
		}));
		setUploadedFile(null);
		console.log('updated Global form', globalForm)
		
	}

	function handleTextAreaChange(event) {
		setFormData({
			...formData,
			textArea: event.target.value,
		})		
	}


	const DocumentComponent = useCallback(({docType, url, fileNanoID, msg=null, resolverRef}) => {
		if (docType?.includes("childSchoolEnrollment")) {
			docType = 'childSchoolEnrollment';
		}
		else if (docType?.includes('childCourseCompletion')) {
			docType = 'childCourseCompletion';
		}
		else if (docType?.includes('other')) {
			docType = 'other'
		}

		function handleClick() {
			onSelect(fileNanoID);
			console.log('handleClick initial resolverRef.current', resolverRef.current)
			resolverRef.current({url: url, nanoID: fileNanoID});
			console.log('handleClick resolverRef.current', resolverRef.current)
		}

		return (
			<div className='container'>
				<DragNDropBriefcase
					text={docsList[docType]} 
					initialFileURL={url} 
					clickCallback={() => {
						props?.setIsVisible('hidden');
						handleClick();
					}}  
					customStyle='pdf-viewer-small'
					fileNanoID={fileNanoID}
					doc={docType}
					documentsPage={true}
					noX={true}
					msg={msg}
				/>
			</div>
		);
	}, [])

	return(
	<div className={`${props?.isVisible} popup little-popup documents-grid-popup`}>
		<BackButton 
			customCssClasses='position-fixed'
			popup={() => {
			props?.setIsVisible('hidden');
			}}
		/>
	<Spacer25 />
	<div className='inner-popup'>
	<FormContext.Provider value={{globalForm, setGlobalForm}}>
		<div className='form-div'>
			<Spacer />
			<h2 className='primary-title'>{lang.documents}</h2>
			<Spacer />
			<div>
		</div>
		
		<Spacer />
		{
// 			clientDocsState.length < 0 &&
			<h2 className='secondary-title centered-text'>{lang.chooseDocument}</h2>
		}
		<Spacer />

		{
			isLoading? <LoadingDocs /> : 
			<div className='upload-grid from-div animated-div' ref={containerRef}>
			{
				globalForm.docs.slice().reverse().map((doc) => {
// 					console.log('doc', doc);
					return (
						<div key={nanoid()}className={uploadedFile === doc.url ? 'hidden' : ''}>
							<DocumentComponent docType={doc.docType} url={doc.url} fileNanoID={doc.uuid} msg={doc.msg} resolverRef={resolverRef}/>
						</div>
					)
				})
			}
			</div>
		}

		</div>
		</FormContext.Provider>
		<FullscreenDocument visible={isIframe} closeFunc={setIsIframe} src={iframeDoc} />
	</div>
	</div>



	);

}
